import React, { useContext } from "react";
import { MediaAuthContext } from "../../../../../../store/context/media-auth-context";
import { HeaderContext } from "../../../../../../store/context/header-context";
// import { TOOLS_TABS } from "../../../content/index.content";
import { updateLinksSite } from "./Links/updateLinks";
import Category from "./Category";
import "./index.scss";

const Site = () => {
  const {
    auth: { isAuth },
  } = useContext(MediaAuthContext);
  const { language } = useContext(HeaderContext);
  // const { getState, language } = useContext(HeaderContext);
  // if (getState.toolsTab !== TOOLS_TABS.SITE) return null;
  const listCategories = updateLinksSite({
    language,
    isSavedUser: isAuth,
  });

  return (
    <div className="GCL-H-T-T GCL-H-T-T_Site">
      {listCategories.map((data, index) => (
        <Category key={index} index={index} {...data} />
      ))}
    </div>
  );
};

export default Site;
